<template>
    <v-form @submit.prevent="applyPromo" ref="form" class="mb-5">
        <v-card
            class="soli-round stripe-shadow animate__animated"
            outlined
            :class="{ animate__shakeX: errors.promo }"
            ><v-row no-gutters
                ><v-list-item-content class="py-0">
                    <v-text-field
                        v-model="promoCode"
                        solo
                        flat
                        hide-details="auto"
                        append-icon=""
                        ref="promoInput"
                        label="Gift or promo code"
                        prepend-inner-icon="redeem"
                        :error-messages="errors.promo || promoErrors"
                    >
                        <!--<v-icon color="dark" slot="prepend-inner"
                            >redeem</v-icon
                        >
                        <div slot="label" class="soli-grey">
                            Gift or promo code
                        </div>-->
                    </v-text-field></v-list-item-content
                ><v-list-item-action class="ma-0"
                    ><SoliBtn
                        color="dark"
                        type="submit"
                        class="mx-1"
                        :loading="promoLoading"
                        >Apply</SoliBtn
                    ></v-list-item-action
                ></v-row
            ></v-card
        >
    </v-form>
</template>

<script>
import FormRules from "../../Mixins/FormRules";

export default {
    props: {
        errors: {
            type: Object,
            default: () => {},
        },
        prices: {
            type: Array,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        user: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            promoCode: this.guest?.promo ?? null,
            activePromo: null,
            showMessage: false,
            promoLoading: false,
            promoInput: null,
            activeGift: null,
            promoErrors: [],
        };
    },
    mounted() {
        if (this.guest?.promo) this.applyPromo();
    },
    methods: {
        applyPromo() {
            if (!this.promoCode) {
                this.promoErrors.push("Please enter a promotion or gift");

                setTimeout(() => {
                    this.promoErrors = [];
                    this.promoCode = null;
                }, 3000);

                return;
            }

            this.promoLoading = true;

            if (this.promoCode.includes("GIFT-")) {
                this.searchGift();
                return;
            }

            if (this.activePromo) {
                this.promoErrors.push(
                    "Sorry, only one promotion is allowed per order"
                ),
                    (this.promoLoading = false);
                setTimeout(() => {
                    this.promoErrors = [];
                    this.promoCode = null;
                }, 3000);
                return;
            }

            axios
                .get(
                    route("promo.search", {
                        code: this.promoCode,
                        prices: this.prices.map((e) => {
                            return {
                                id: e.id,
                                quantity: e.quantity ?? 1,
                            };
                        }),
                        customer_id: this.user?.id ?? null,
                        guest_id: this.guest?.id ?? null,
                    })
                )
                .then((e) => {
                    if (e.data.error) {
                        this.promoErrors.push(e.data.error);
                        this.promoLoading = false;
                        setTimeout(() => {
                            this.promoErrors = [];
                            this.promoCode = null;
                        }, 3000);
                        return;
                    } else {
                        //this.activeGift = null;
                        this.activePromo = e.data;
                        this.$emit("applyPromo", this.activePromo);
                        this.$page.props.successMessage = "Promo Applied!";
                        this.promoCode = null;
                        this.promoLoading = false;
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                    this.promoLoading = false;
                });
        },
        searchGift() {
            if (this.activeGift) {
                this.promoErrors.push(
                    "Sorry, only one gift certificate is allowed per order"
                );
                this.promoLoading = false;
                setTimeout(() => {
                    this.promoErrors = [];
                    this.promoCode = null;
                }, 3000);
                return;
            }
            axios
                .get("/api/gift-cards/search", {
                    params: {
                        redemptionCode: this.promoCode,
                    },
                })
                .then((result) => {
                    if (result.data.error) {
                        console.log(result.data.error);
                        this.promoErrors.push(result.data.error);
                        this.promoLoading = false;
                        setTimeout(() => {
                            this.promoErrors = [];
                            this.promoCode = null;
                        }, 3000);
                    } else {
                        this.activePromo = null;
                        this.activeGift = result.data;
                        this.$emit("applyGift", this.activeGift);
                        this.$page.props.successMessage =
                            "Gift Certificate Applied!";
                        this.promoCode = null;
                        this.promoLoading = false;
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                    this.promoLoading = false;
                });
        },
    },
    computed: {
        showApply() {
            return !!this.promoInput || this.promoLoading;
        },
    },
    watch: {
        prices: {
            handler: function (cart) {
                if (this.activePromo) {
                    this.promoCode = this.activePromo.code;
                    this.applyPromo();
                }
            },
            deep: true,
        },
    },
};
</script>
